export default class PopUp {
	constructor(element) {
		 this.popUpToggle = element.querySelector('.js-popUp-toggle');
		 this.popUpPoster = element.querySelector('.js-popUp-poster');
		 this.target = element.querySelector('.js-popUp--target');
		 this.trigger = element.querySelector('.js-popUp-trigger');
		 this.background = element.querySelector('.js-popUp__background');
		 this.cross = element.querySelector('.js-popUp__icon');

		 this.init();
	}

	init() {
		 const togglePopUp = () => {
			  this.target.classList.toggle('js-popUp--hidden');
		 };

		 this.trigger.addEventListener('click', togglePopUp);
		 this.background.addEventListener('click', togglePopUp);
		 this.cross.addEventListener('click', togglePopUp);

		 // Handle keydown event for tab navigation
		 this.trigger.addEventListener('keydown', (event) => {
			  if (event.key === 'Enter' || event.key === 'Space') {
					togglePopUp();
			  }
		 });

		 // Handle touchstart and touchend events for iOS
		 this.trigger.addEventListener('touchstart', togglePopUp);
		 this.trigger.addEventListener('touchend', (event) => {
			  event.preventDefault(); // Prevent triggering 'click' after 'touchend'
		 });
	}
}
